
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CustomRouterView2',
  setup() {},
  components: {},
});
